import React, {
  createContext, ReactNode, useContext, useMemo, useState,
} from 'react';
import { ManufacturerOption } from '../components/pages/ProductDetail/SmartlockDetail/DoorKnobSection/types/ManufacturerOption';
import { SmartlockContextType } from './types/SmartlockContextType';

// Create the context with a default undefined value
const SmartLockContext = createContext<SmartlockContextType | undefined>(undefined);

// Smartlock context provider component
export function SmartLockContextProvider({ children }: { children: ReactNode }) {
  const [hasDoorKnob, setHasDoorKnob] = useState<boolean>(false); // doorknob selection
  const [selectedManufacturer, setSelectedManufacturer] = useState<ManufacturerOption | undefined>(
    undefined,
  ); // doorknob manufacturer selection

  const value = useMemo(
    () => ({
      hasDoorKnob,
      selectedManufacturer,
      setHasDoorKnob,
      setSelectedManufacturer,
    }),
    [hasDoorKnob, selectedManufacturer],
  );

  return <SmartLockContext.Provider value={value}>{children}</SmartLockContext.Provider>;
}

// Custom hook to use the context
export const useSmartLockContext = (): SmartlockContextType => {
  const context = useContext(SmartLockContext);
  if (context === undefined) {
    // err message mainly for developer in case of wrong context usage
    throw new Error('useSmartLockContext must be used within a SmartLockProvider');
  }
  return context;
};
